import { createPropsSelector } from './utils';

export const selectSalaryExportConfigurations = (state) => state.bo.salaryExports.salaryExportConfigurations;

export const selectSalaryExportConfigurationsByProps = createPropsSelector(selectSalaryExportConfigurations);
